// import {cellS,headerS} from '../st/cStyle'


// let nevEve='always';

// export var columnsInv = [
//   // {title: "id", field: "id", hidden: true},
//   {title: "id", field: "currency_from",headerStyle: headerS,cellStyle: cellS, hidden: true},
//   {title: "رقم الباركود", field: "barcode", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "الصنف", field: "symbol", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "الوحدة", field: "unitame",  editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   // {title: "الكمية", field: "val1", type: 'numeric', headerStyle: headerS,cellStyle: cellS,},
//   { title: 'الكمية', field: 'val1', headerStyle: headerS,cellStyle: cellS, editComponent: props => (
//       <TextField type="text" variant="outlined" size="small"
//       value={props.value} onChange={e => props.onChange(e.target.value)} /> )},
//   {title: "العبوة", field: "val", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "السعر", field: "exchange_price", type: 'numeric',editable:nevEve, headerStyle: headerS,cellStyle: cellS,
//     editComponent: props => (<TextField type="text" variant="outlined" size="small"
//     value={props.value} onChange={e => props.onChange(e.target.value)} /> )},
//   {title: "الإجمالي", field: "totJust", editable:'never',headerStyle: headerS,cellStyle: cellS,},
//   {title: "قيمة الخصم", field: "discount",type: 'numeric',  editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "الخصم%", field: "DiscPers", type: 'numeric',editable:nevEve, headerStyle: headerS,cellStyle: cellS,
//     editComponent: props => ( <TextField type="text" variant="outlined" size="small"
//     value={props.value} onChange={e => props.onChange(e.target.value)} /> )},
//   {title: "الإجمالي بعد الخصم", field: "totAfterDisc", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "القيمة المضافة%", field: "taxperc", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "إجمالي القيمة المضافة", field: "taxval", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "الصافي", field: "new_exchange_price", editable:'never', headerStyle: headerS,cellStyle: cellS,},
//   {title: "معلومات", field: "", hidden: true,headerStyle: headerS,cellStyle: cellS,
//     editComponent: props => ( <TextField type="text" variant="outlined" size="small"
//     value={props.value} onChange={e => props.onChange(e.target.value)} /> )},
//   {title: "البيان", field: "notes", headerStyle: headerS,cellStyle: cellS,
//     editComponent: props => ( <TextField type="text" variant="outlined" size="small"
//     value={props.value} onChange={e => props.onChange(e.target.value)} /> )},
//   {title: "سعر البيع", field: "sale_price", headerStyle: headerS,cellStyle: cellS,
//     editComponent: props => ( <TextField type="text" variant="outlined" size="small"
//     value={props.value} onChange={e => props.onChange(e.target.value)} /> )
//   }
// ]




var col = {
  Branches:[
    {title: "", field: "id", hidden: true},
    {title: "branch-name", field: "name", },
    {title: "telephone", field: "Tel", },
    {title: "mobile-number", field: "Mobile", },
    {title: "fax-number", field: "Fax", },
    {title: "email", field: "Email", },
  ],
  Units : [
    {title: "number", field: "id", },
    {title: "unit", field: "name",},
  ],
  items : [
    {title: "number", field: "id", },
    {title: "item", field: "symbol",},
    {title: "barcode", field: "barcode",},
    {title: "group", field: "groupName",},
    {title: "purchase", field: "purch_price",},
    {title: "sale", field: "sale_price",},
    {title: "location", field: "Location",},
  ],
  groups : [
    {title: "number", field: "id", hidden: true },
    {title: "group-code", field: "group_id",},
    {title: "product-group", field: "name",},
  ],
  tax_groups : [
    // {title: "الرقم", field: "id", },
    // {title: "رقم الصنف", field: "nameAR", },
    // {title: "الصنف", field: "id", },
    {title: "number", field: "id", },
    {title: "tax-name", field: "nameAR", },
    {title: "tax-percentage", field: "value", },
  ],
  Safes : [
    {title: "", field: "id", hidden: true },
    {title: "", field: "branch", hidden: true },
    {title: "safe-name", field: "name", },
    {title: "branch", field: "branchName", },
  ],
  Stocks : [
    {title: "", field: "id", hidden: true },
    {title: "", field: "branch", hidden: true },
    {title: "stock-name", field: "name", },
    {title: "branch", field: "branchName", },
  ],
  Banks : [
    {title: "", field: "id", hidden: true},
    {title: "bank-name", field: "name", },
    {title: "country", field: "CountryName", },
    {title: "city", field: "CityName", },
    {title: "area", field: "AreaName", },
    {title: "telephone", field: "tel", },
    {title: "mobile-number", field: "mobile", },
    {title: "account-number", field: "acc_no", },
  ],
  costcenter : [
    {title: "number", field: "id", },
    {title: "cost-center", field: "Name",},
  ],

  omlat : [
    {title: "number", field: "id", },
    {title: "currency-name", field: "name", },
    {title: "latin-name", field: "NameEn", },
    {title: "currency-symbol", field: "symbol", },
    {title: "exchange-rate", field: "exchange", },
    {title: "status", field: "IS_Active", },
    {title: "default-currency", field: "is_main", },
    //{title: "العمله المحلية", field: "IS_Default", },
    {title: "country", field: "Country", },
    {title: "fraction-name-ar", field: "FakaName", },
    {title: "fraction-name-en", field: "FakaNameEn", },
    {title: "one-equals", field: "oneEqualto", },
    {title: "equivalent", field: "TotalFaka", },
    {title: "description", field: "omla_desc", },
  ],
  AccountBooks : [
    {title: "number", field: "ID", },
    {title: "book-name", field: "Name",},
  ],
  Acts : [
    {title: "", field: "id", hidden: true},
    {title: "group-name", field: "name", },
    {title: "group-type", field: "nameType", },
    {title: "", field: "type", hidden: true},
  ],
  Countries : [
    {title: "number", field: "id", },
    {title: "country-name", field: "name", },
    // {title: "الجنسية", field: "name",},
  ],
  Cities : [
    {title: "number", field: "id", },
    {title: "city-name", field: "name", },
    // {title: "اسم المدينة", field: "country",},
    // {title: "اسم المدينة", field: "country",},
  ],
  Areas : [
    {title: "number", field: "id", },
    {title: "area-name", field: "name", },
    // {title: "اسم المدينة", field: "city",},
    // {title: "اسم المنطقة", field: "nameA",},
  ],
  Managements : [
    {title: "number", field: "id", hidden: true },
    {title: "management-name", field: "name",},
  ],
  Departments : [
    {title: "number", field: "id", hidden: true },
    {title: "department-name", field: "name",},
    {title: "department-management-name", field: "manag_id",},
  ],
  jobs : [
    {title: "number", field: "id", hidden: true },
    {title: "job", field: "name",},
  ],
  CardTypes : [
    {title: "number", field: "id", hidden: true },
    {title: "card-name", field: "nameA",},
  ],
} 

  export {col};